var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftCallAction = function SvgLeftCallAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 297 597"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#left-call-action_svg__a)",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    d: "M243.113 298.35c0 135.094-109.772 244.611-245.187 244.611S-247.26 433.444-247.26 298.35c0-135.093 109.772-244.611 245.187-244.611S243.113 163.257 243.113 298.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#left-call-action_svg__b)",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    d: "M-300.25 298.35C-300.25 133.992-166.753.75-2.074.75c164.68 0 298.176 133.242 298.176 297.6S162.605 595.95-2.074 595.95-300.25 462.709-300.25 298.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#left-call-action_svg__c)",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    d: "M-190.817 298.926c0-104.239 84.503-188.742 188.743-188.742s188.742 84.503 188.742 188.742c0 104.24-84.503 188.743-188.742 188.743-104.24 0-188.743-84.503-188.743-188.743Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "left-call-action_svg__a",
    x1: -248.011,
    x2: 243.863,
    y1: 543.711,
    y2: 543.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "left-call-action_svg__b",
    x1: 296.852,
    x2: -301,
    y1: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "left-call-action_svg__c",
    x1: 187.418,
    x2: -191.567,
    y1: 109.434,
    y2: 109.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0.5
  })))));
};
export default SvgLeftCallAction;